//@ts-ignore
import { FileUpload } from "@careinfo/file-upload-service";
import TabPanel from "../Reusable/Tab";
import EditDailyNote from "./EditDailyNote";

const SwitchTab = (props: any) => {
  const {
    handleEdit,
    isLoading,
    data,
    id,
  } = props;

  return (
    <>
      <TabPanel
        tabTitle={["Update", "Documents"]}
        tabPanels={[
          <>
            <EditDailyNote
              handleEdit={handleEdit}
              isLoading={isLoading}
              data={data}
            />
          </>,
          <>
            <FileUpload object_id={id} />
          </>,
        ]}
      />
    </>
  );
};

export default SwitchTab;
